/*eslint-disable*/export const messages=JSON.parse("{\"common.sponsorLabel\":[\"Annons\"]}");